module.exports = __webpack_public_path__ + "student@2x.f420bcbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Student/images/student@2x.png
// module id = etGk
// module chunks = 0